import { FormatOptionLabelMeta as _FormatOptionLabelMeta } from 'react-select/base';
export type FormatOptionLabelMeta<Option> = _FormatOptionLabelMeta<Option>;

export { Autocomplete } from './Autocomplete';
export { AutocompleteField } from './AutocompleteField';
export type {
  AutocompleteProps,
  BaseOption,
  EntityDetailOption,
} from './types';
export {
  entityDetailOptionRenderer,
  entityOptionRenderer,
  userOptionRenderer,
} from './option-renderers';
